<template>
  <div>
    <div class="scrollable">
      <div class="page-header">
        <div
          class="page-header header-accent-gradient card-base card-shadow--small"
          style="
            border-bottom-left-radius: 0;
            border-bottom-right-radius: 0;
            margin-bottom: 0 !important;
          "
        >
          <h1>HISTORICO JOBS</h1>

          <!-- <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">
            <a><i class="mdi mdi-home-outline"></i></a>
          </el-breadcrumb-item>
    </el-breadcrumb> -->
        </div>
      </div>
    </div>
    <div class="block">
      <el-date-picker
        v-model="value1"
        type="datetimerange"
        range-separator="To"
        start-placeholder="Start date"
        end-placeholder="End date"
        format="dd-MM-yyyy HH:mm:ss"
        value-format="yyyy-MM-dd HH:mm:ss"
      >
      </el-date-picker>
    </div>

    <el-row>
      <el-col>
        <rabbey-table3
          ref="table"
          :loading="loading"
          :data="items"
          :columns="columns"
          :actions="actions"
        />
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { formatDate } from "@/utils";

export default {
  name: "HistoryJobs",
  created() {
    // this.value1 = [new Date("dd-MM-yyyy HH:mm:ss"), new Date("dd-MM-yyyy HH:mm:ss")]
    this.getTableData();
  },
  watch: {
    value1() {
      // console.log("ssss", this.value1);
      this.getTableData();
    }
  },
  data() {
    return {
      value1: [
        new Date().toDateString("dd-MM-yyyy HH:mm:ss"),
        new Date().toDateString("dd-MM-yyyy HH:mm:ss")
      ],

      items: [],

      activeIndex: "/HistoryJobs/HistoryJobs",
      actions: [
        {
          icon: "el-icon-view",
          label: "Ver Jobs",
          command: "view"
        }
      ],
      columns: [
        {
          prop: "JobName",
          label: "Nombre Jobs",
          sortable: true
        },
        {
          prop: "StartDate",
          label: "Fecha de Inicio",
          sortable: true,
          formatter: (props) => {
            // console.log(props)
            return formatDate(props.StartDate);
          }
        },
        {
          prop: "EndDate",
          label: "Fecha de Finalizacion",
          sortable: true,
          formatter: (props) => {
            // console.log(props)
            return formatDate(props.EndDate);
          }
        },
        {
          prop: "Duracion",
          label: "Duracion",
          sortable: true
        }
      ]
    };
  },
  pickerOptions: {},
  value1: [new Date(), new Date()],
  value2: "",
  methods: {
    getTableData(options) {
      if (!options) {
        options = {};
      }

      this.loading = true;
      this.$http
        .get(
          `/api/tennos/GetHistoricoJobs?fecha=${this.value1[0]}&horahasta=${this.value1[1]}`
        )

        .then((response) => {
          // const {
          //   data: {Items}
          // } = response;

          this.items = response.data;
          this.loading = false;
          // console.log(response);
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.block.compact {
  width: 100px;
}

.el-date-picker {
  width: 100px;
}
.block {
  margin-left: 0%;
  margin-bottom: 15px;
  &:last-child {
    margin-bottom: 0;
  }
}
</style>
